export const linkPadding = 10;
export const iconSize = 30;
export const breadcrumbsHeight = linkPadding * 2 + iconSize;
